// extracted by mini-css-extract-plugin
export default {"root":"VideoFrame-module__root--JvVToR","iframe":"VideoFrame-module__iframe--CGSCba"};